<template>
    <div class="order-list-wrap">
        <div class="info-item" v-for="(order, index) in list" :key="index" @click.stop="$router.push(`/refund-service-detail?refund_id=${order.id}`)">
            <div class="info-title">
                <!-- <div class="refund-type">
                    {{ order.typeInfo }}
                </div> -->
                <div class="myFlexBox">
                    <div class="date">{{ order.createdTime }}</div>
                    <div class="order-code">
                        订单号：
                        <span>{{ order.sn }}</span>
                    </div>
                </div>
                <!-- <div class="order-state" :class="'state' + order.status">
                    {{ order.statusInfo }}
                </div> -->
                <div class="orderStatusType" v-if="order.type == 1">
                    <img src="@/assets/img/mine/money.png" class="orderStatusIcon" alt="" />
                    <div class="text">仅退款</div>
                </div>

                <div class="orderStatusType" v-else-if="order.type == 2">
                    <img src="@/assets/img/mine/tui.png" class="orderStatusIcon" alt="" />
                    <div class="text">退货退款</div>
                </div>

                <div class="orderStatusType" v-else-if="order.type == 3">
                    <img src="@/assets/img/mine/huan.png" class="orderStatusIcon" alt="" />
                    <div class="text">换货</div>
                </div>
            </div>
            <div class="info-good">
                <div class="list-good">
                    <div class="item-good">
                        <div class="img-box">
                            <el-image class="elImg" :src="order.products.image" fit="cover"></el-image>
                        </div>
                        <div class="title">{{ order.products.title }}</div>
                        <div class="num">{{ order.products.keyVals }}</div>
                        <div class="num">x {{ order.products.num }}</div>
                        <div class="price">￥{{ order.products.priceSale }}</div>
                    </div>
                </div>
            </div>
            <div class="info-title" style="border-bottom: none">
                <div>
                    <span class="infoText">{{ order.statusInfo }}</span
                    >&nbsp&nbsp&nbsp&nbsp<span class="infoText2">{{ order.typeInfo }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'orderList',
    components: {},
    props: ['list'],
    data() {
        return {}
    },
    computed: {},
    methods: {},
}
</script>

<style scoped lang="less">
.order-list-wrap {
    .info-item {
        border: 1px solid #e5e5e5;
        margin-bottom: 24px;
        cursor: pointer;
    }

    .infoText {
        font-size: 14px;
        color: #333333;
    }

    .infoText2 {
        font-size: 14px;
        color: #888888;
    }

    .orderStatusType {
        display: flex;
        align-items: center;
        justify-content: center;

        .orderStatusIcon {
            width: 22px;
            display: block;
            margin-right: 4px;
        }

        .text {
            font-size: 14px;
            line-height: 14px;
            color: #ff4d00;
        }
    }

    .info-title {
        .flex();
        justify-content: space-between;
        height: 44px;
        padding: 0 24px;
        background: #f5f5f5;
        border-bottom: 1px solid #e5e5e5;

        .myFlexBox {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .refund-type {
            min-width: 80px;
            text-align: left;
            color: #ff4d00;
        }

        .date {
            font-weight: bold;
            font-size: 14px;
            color: #333333;
            line-height: 14px;
        }

        .order-code {
            padding-left: 20px;

            font-weight: bold;
            font-size: 14px;
            color: #333333;
            line-height: 14px;
        }
        .order-state {
            padding: 3px 6px;
            border: 1px solid #ccc;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            color: #999999;

            &.state2 {
                color: #ff4d00;
                border-color: #ff4d00;
            }
        }
    }

    .info-good {
        .list-good {
            .item-good {
                padding: 20px 24px;
                border-bottom: 1px dashed #ccc;
                cursor: pointer;
                .flex();

                &:last-child {
                    border: none;
                }

                .img-box {
                    width: 120px;
                    height: 83px;
                    cursor: pointer;
                    border: 1px solid #9f9f9f;
                    overflow: hidden;
                    .elImg {
                        width: 120px;
                        height: 83px;
                    }
                }
                .title {
                    text-align: center;
                    padding-left: 20px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 14px;
                    flex: 1;
                }
                .num {
                    flex: 1;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 14px;
                    text-align: center;
                }
                .price {
                    min-width: 100px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 14px;
                    text-align: end;
                }
            }
        }
    }
    .info-heji {
        padding: 15px;
        border-top: 1px solid #ccc;
        .flex-between();
        justify-content: flex-end;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 20px;
        color: #7d7d7d;

        .order-detail {
            min-width: 96px;
            height: 30px;
            background: #ff4d00;
            border: 1px solid #ff4d00;
            font-size: 14px;
            color: #fff;
            transition: 0.3s;

            &:hover {
                opacity: 0.8;
            }
        }
    }
}
</style>
